import en from './en';
import es from './es';

export const Translations = {
  es: {translation: es},
  en: {translation: en},
};

export default Translations;
